import NotFound from './component'

export default NotFound
